import { TinyColor } from '@ctrl/tinycolor';
export const getStyleColor = (appSettings, wixParam) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = appSettings === null || appSettings === void 0 ? void 0 : appSettings.style) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b[wixParam]) === null || _c === void 0 ? void 0 : _c.value;
};
export const getPresetColor = (appSettings, presetName) => {
    var _a, _b;
    return (_b = (_a = appSettings === null || appSettings === void 0 ? void 0 : appSettings.colorPresets) === null || _a === void 0 ? void 0 : _a.find((p) => (p === null || p === void 0 ? void 0 : p.reference) === presetName)) === null || _b === void 0 ? void 0 : _b.value;
};
export const setColorOpacity = (color, alpha = 1) => new TinyColor(color).setAlpha(alpha).toRgbString();
export const getSiteColor = (appSettings, { wixParam, presetFallback, colorFallback, opacity = undefined, }) => {
    const color = getStyleColor(appSettings, wixParam) ||
        getPresetColor(appSettings, presetFallback) ||
        colorFallback;
    return opacity !== undefined
        ? setColorOpacity(color, opacity)
        : new TinyColor(color).toRgbString();
};
export const resolveColor = (color, colorPresets) => {
    if (!color) {
        return 'transparent';
    }
    if (!color.includes('{')) {
        return color;
    }
    const currentColor = color.replace(/[\{\}]/g, '');
    const siteColor = colorPresets === null || colorPresets === void 0 ? void 0 : colorPresets.find(({ name }) => name === currentColor);
    return (siteColor === null || siteColor === void 0 ? void 0 : siteColor.value) || 'transparent';
};
//# sourceMappingURL=colors.js.map